export default __webpack_public_path__ + "static/media/alertsSelected.366c7a10.svg";